// 去識別的警報（委派方要求兩步驟驗證，SPEC #org-tree-ui「委派方要求兩步驟驗證時的警報推播」，Eddy 2026-10-09 選單 A）：
// 收件匣點開不直接開事件（會 403 ORG_MFA_REQUIRED），先說明：〈委派方〉有一則警報——開啟兩步驟驗證並重新登入後才看得到內容，
// 〔設定兩步驟驗證〕到帳號安全設定；設好、重新登入後〔回到這則警報〕。
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';

export function MfaAlarmNotice() {
  const { t } = useTranslation();
  const [q] = useSearchParams();
  const from = q.get('from') || t('inbox.mfa_alarm_someone');
  // 回到警報：只收家戶與事件 id、這裡自己組事件頁路徑（不接任意網址或路徑，kops 審查 !32）
  const home = q.get('home') ?? '';
  const event = q.get('event') ?? '';
  const ok = (s: string) => /^[A-Za-z0-9_-]{1,80}$/.test(s);
  const safeNext = ok(home) && ok(event) ? `/events/${encodeURIComponent(home)}/${encodeURIComponent(event)}` : '';
  return (
    <section className="card" data-testid="mfa-alarm-notice">
      <h1 className="page-title">🔒 {t('inbox.mfa_alarm_title', { from })}</h1>
      <p>{t('inbox.mfa_alarm_body')}</p>
      <p className="row">
        <Link className="btn btn-primary" to="/settings">
          {t('ot.setup_mfa')}
        </Link>
        {safeNext && (
          <Link className="btn" to={safeNext}>
            {t('inbox.mfa_alarm_back')}
          </Link>
        )}
      </p>
    </section>
  );
}
